module.exports = __webpack_public_path__ + "static/media/react-firebase.3257acff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/react-firebase.png
// module id = 30
// module chunks = 0